'use strict';

var setArrayChainableConstructor = require('../internal/setArrayChainableConstructor');

setArrayChainableConstructor();


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/build/setArrayChainableConstructorCall.js
// module id = 361
// module chunks = 0